import Stack from '@/components/v3/Stack';
import AppScreenPublishButtons from './AppScreenPublishButtons';
import { MdMoreVert } from '@/components/react-icons/main';
import Button from '@/components/Button';
import FloatingPaneV2 from '@/components/v2/FloatingPaneV2';

const AppScreenPublishActions = () => {
  return (
    <div className="app-screen-publish-actions">
      <Stack gap={8} className="desktop">
        <AppScreenPublishButtons />
      </Stack>

      <div className="tablet">
        <Button icon={MdMoreVert} className="app-expand-publish-section" size="sm">
          Publish Actions
        </Button>
        <FloatingPaneV2 triggers={['.app-expand-publish-section']} offset={8}>
          <Stack gap={8} className="app-expand-publish-section-content">
            <AppScreenPublishButtons />
          </Stack>
        </FloatingPaneV2>
      </div>
    </div>
  );
};

export default AppScreenPublishActions;
